import React, { useState } from 'react';
import Input from '../input/index.jsx';
import Title from '../title/index.jsx';

const ColorPicker = ({ defaultValue = '#000000', label = false, onChange, style: overwriteStyle = {}, ...attr }) => {
  const [color, setColor] = useState(defaultValue);

  const handleOnChange = (event) => {
    const { target: { value } } = event;
    setColor(value);
    onChange(event);
  };

  return (
    <div style={overwriteStyle}>
      {label && <Title type="h6">{label}</Title>}
      <div style={styles.container}>
        <div style={{ ...styles.colorInputContainer, backgroundColor: color }}>
          <input style={styles.colorInput} type="color" value={color} onChange={handleOnChange} {...attr} />
        </div>
        <Input style={styles.input} value={color} onChange={handleOnChange} {...attr} />
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
  },
  colorInputContainer: {
    height: 46,
    width: 46,
    position: 'relative',
    border: '1px solid black',
    borderRight: 'none',
  },
  colorInput: {
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    height: 46,
    width: 46,
    border: 'none',
    padding: 0,
    position: 'absolute',
    top: 1,
    left: 1,
    opacity: 0,
  },
  input: {
    width: 90,
    maxWidth: 90,
    height: 44,
  },
};

export default ColorPicker;
